export default __webpack_public_path__ + "static/media/CV_FRENCH.17fbb059.pdf";